import { render } from "./Home.vue?vue&type=template&id=4e88dd56&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4e88dd56&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4e88dd56"

export default script